export const BeautyAdvice = [
  {
    src: "https://images-static.nykaa.com/uploads/71c7558d-637c-40ee-b09b-7dfda35cf125.jpg?tr=w-1200,cm-pad_resize",
    text: "Catch Up On Top Trends,Expets Advice ,Fresh Launchers & More",
    disc: "Watch Now",
  },
  {
    src: "https://images-static.nykaa.com/uploads/a3720b61-fd58-40ff-90cd-72eb5b5ee3d4.jpg?tr=w-1200,cm-pad_resize",
    text: "Catch Up On Top Trends,Expets Advice ,Fresh Launchers & More",
    disc: "read More",
  },
];